import { render, staticRenderFns } from "./ViewUser.vue?vue&type=template&id=421f20a2&scoped=true&"
import script from "./ViewUser.vue?vue&type=script&lang=ts&"
export * from "./ViewUser.vue?vue&type=script&lang=ts&"
import style0 from "./ViewUser.vue?vue&type=style&index=0&id=421f20a2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "421f20a2",
  null
  
)

export default component.exports